// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2xmqC","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2Mk5R"};